import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  subscriptionData: null,
  isActive: false,
  lastUpdated: null,
  // Add persistence flags
  isPersisted: false,
  pendingNavigation: false,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    saveSubscriptionData: (state, action) => {
      state.subscriptionData = action.payload;
      state.isActive = true;
      state.lastUpdated = new Date().toISOString();
      state.isPersisted = false; // Will be set to true by persistSubscriptionData
      state.pendingNavigation = true;
      console.log('🔄 Subscription data saved to Redux:', action.payload);
    },
    clearSubscriptionData: (state) => {
      state.subscriptionData = null;
      state.isActive = false;
      state.lastUpdated = null;
      state.isPersisted = false;
      state.pendingNavigation = false;
      console.log('🗑️ Subscription data cleared from Redux');
    },
    updateSubscriptionStatus: (state, action) => {
      state.isActive = action.payload.isActive;
      if (action.payload.subscriptionData) {
        state.subscriptionData = { ...state.subscriptionData, ...action.payload.subscriptionData };
      }
      state.lastUpdated = new Date().toISOString();
    },
    // New actions for better data management
    markNavigationComplete: (state) => {
      state.pendingNavigation = false;
      console.log('✅ Navigation marked as complete in Redux');
    },
    persistSubscriptionData: (state) => {
      state.isPersisted = true;
      console.log('💾 Subscription data marked as persisted in Redux');
    },
    restoreSubscriptionData: (state, action) => {
      if (action.payload) {
        state.subscriptionData = action.payload.subscriptionData;
        state.isActive = action.payload.isActive;
        state.lastUpdated = action.payload.lastUpdated;
        state.isPersisted = true;
        console.log('🔄 Subscription data restored to Redux:', action.payload);
      }
    },
  },
});

export const { 
  saveSubscriptionData, 
  clearSubscriptionData, 
  updateSubscriptionStatus,
  markNavigationComplete,
  persistSubscriptionData,
  restoreSubscriptionData
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
